module.exports = __webpack_public_path__ + "static/media/step-sign-contract-icon.9d194108.svg";